import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PopoverService } from '../../../components/popover/popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import icPerson from '@iconify/icons-ic/twotone-person';
import decode from 'jwt-decode';
import { UserProfileService } from '../../../../app/helpers/services/user-profile.service';

@Component({
    selector: 'vex-toolbar-user',
    templateUrl: './toolbar-user.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ToolbarUserComponent implements OnInit {
  dropdownOpen = false;
  icPerson = icPerson;

  /** First name from the JWT token — shown immediately without waiting for API */
  firstName = '';

  constructor(
    private readonly popover: PopoverService,
    private readonly cd: ChangeDetectorRef,
    readonly userProfileService: UserProfileService,
  ) {}

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    if (token) {
      const payload = <any>decode(token);
      // Show first word of the name claim immediately (no API round-trip)
      this.firstName = (payload.name || '').split(' ')[0];
    }
    // Load full profile (including photo) in the background
    this.userProfileService.loadProfile().then(() => this.cd.markForCheck());
  }

  showPopover(originRef: HTMLElement): void {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      // Pass the (stable) profile button so the dropdown can anchor the
      // grid-customize popover to it after the dropdown itself closes.
      data: originRef,
      offsetY: 12,
      position: [
        { originX: 'center', originY: 'top',    overlayX: 'center', overlayY: 'bottom' },
        { originX: 'end',    originY: 'bottom',  overlayX: 'end',    overlayY: 'top'    },
      ],
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
